import type { JourneyJson } from '../types/JourneyJson';

/**
 * Display identity of a journey, independent of its position in the results list:
 * first-leg departure, arrival, and the ordered leg lines (walking legs contribute the
 * literal `walk`). Repeats across journeys that render alike, so pair it with
 * `withUniqueKeys` before using it as an `{#each}` key.
 */
export function journeySignature(journey: JourneyJson): string {
  const firstDeparture = journey.legs.length > 0 ? journey.legs[0].departure : '';
  const legSignature = journey.legs
    .map((journeyLeg) => (journeyLeg.type === 'transit' ? journeyLeg.line : 'walk'))
    .join('>');
  return `${firstDeparture}|${journey.arrival}|${legSignature}`;
}
